import { addToast, removeToast } from '@app/reducer/toasts';
import { generateToastNotificationId } from '@app/selectors/toastsSelectors';

const DEFAULT_TIMEOUT = 3000;

// eslint-disable-next-line import/prefer-default-export
export function showToast(message, { type, timeout } = {}) {
  return (dispatch, getState) => {
    const id = generateToastNotificationId(getState());
    dispatch(addToast(id, message, type));
    setTimeout(() => dispatch(removeToast(id)), timeout || DEFAULT_TIMEOUT);
  };
}



// WEBPACK FOOTER //
// ./src/actions/toasts.js